/**
 * Query-string compaction for Nest ValidationPipe.
 *
 * Empty strings (`status=`, `organizationId=`) fail `@IsUUID` / `@IsEnum` /
 * `@IsOptional` (optional only skips null/undefined). After C-Back-End #137
 * the API treats unset optional filters as omitted — the SPA must not send
 * blanks in the first place.
 */
export function compactQueryParams(
  params: Record<string, unknown>,
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;
    if (typeof value === 'string' && value.trim() === '') continue;
    if (Array.isArray(value)) {
      if (value.length === 0) continue;
      out[key] = value.map(String).join(',');
      continue;
    }
    out[key] = String(value);
  }
  return out;
}
